
export class CmaState {
	public isTransientPortfolioEdited: boolean = false;
}
